export const WORKER_ROLE: string = 'worker';
export const HR_ROLE: string = 'hr';

export enum UserRoles {
  "WORKER" = "worker",
  "HR" = "hr",
}

// export const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzE4MjI1ODYzLCJpYXQiOjE3MTgyMjQ5NjMsImp0aSI6Ijc0MmExN2QwYjRjYzRiNTk5OTRkMjM4ZmQ4MWE3YWI3IiwidXNlcl9pZCI6IjM4NWRiMzhmLWYwMDItNDkxNS05NzFlLThmYWFlYWQ2N2EzNSJ9.EsJniuVa-rlck8KU__pJfU3EJ4MSTLKurtN3IeRxKMY";
export const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzE4MzkwMTA2LCJpYXQiOjE3MTgzODkxMDQsImp0aSI6ImY2YWUxYzZkZDQwMjQ2YTg5OTIwMmZhMjk4OGM5MWU5IiwidXNlcl9pZCI6ImU1ODdhYTc5LTEwODUtNDJhYy1hYjYzLTMwNTdmYjcxNTBjOCJ9.dId0rPWPZBjmKbpCRQBVBje_lqHtpBSdvQUgKIqX970"